module.exports = __webpack_public_path__ + "static/media/inspoBoard.00718081.png";